export default __webpack_public_path__ + "static/media/AnarchistSolution.43b99252.pdf";